export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderGroups@3x.png";